import React, {useEffect, useState} from "react";
import MobFilterItem from "../mobFilterItem/MobFilterItem";
import { motion } from 'framer-motion';
import { countProjects } from "../../globals/helpers";
import { workTags } from "../../globals/data";

const MobArchiveFilters = ({activeFilter, setActiveFilter, projData}) => {

    const mobFilterWrapperVariants = {
        initial: {
            transition: {
                staggerChildren: 0.05
            }
        }, animate: {
            transition: {
                staggerChildren: 0.05
            }
        }, exit: {
            transition: {
                staggerChildren: 0.05
            }
        }
    }

    const [filterInfo, setFilterInfo] = useState(null);

    useEffect(() => {
        let [tmpFilterInfo, totalItems] = countProjects(projData, workTags);
        tmpFilterInfo['0'] = {
            name: "ALL",
            count: totalItems
        };
        setFilterInfo(tmpFilterInfo);
    }, [])

    function handleFilterSelection(idx){
        setActiveFilter(idx)
    }

    return(
        <motion.div 
            className="mob_filter_opts_wrapper"
            variants={mobFilterWrapperVariants}
        >
            {
                filterInfo &&
                Object.entries(filterInfo).map(([k, value], idx) => (
                    <MobFilterItem
                        title={value.name.replace("_", ' ')}
                        projNum={value.count}
                        fiIdx={k}
                        handleFilterSelection={handleFilterSelection}
                        isCurActive={k == activeFilter}
                    />
                    
                ))
            }
        </motion.div>
    )
}

export default MobArchiveFilters